import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import cs from '../locales/cs.json'
import en from '../locales/en.json'

import { initReactI18next } from 'react-i18next'

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    resources: {
      en,
      cs,
    },
    detection: {
      order: ['localStorage', 'navigator'],
    },
  })

export default i18n
